export class ListItem {
    constructor(
        public valor: string,
        public texto: string,
    ) {}
}
